import { render, staticRenderFns } from "./MyBucketLists.vue?vue&type=template&id=79031d6c&"
import script from "./MyBucketLists.vue?vue&type=script&lang=js&"
export * from "./MyBucketLists.vue?vue&type=script&lang=js&"
import style0 from "./MyBucketLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports